/* ── Admin Duration Service (ES Module) ── */
import { catalog, selectedChannel } from './admin-globals.js';
import { showToast } from './admin-ui-base.js';
import { renderVideoList } from './catalog-ui.js';
import { fetchDuration, normalizeYoutubeVideoId } from './admin-yt.js';

function needsDurationSeconds(val) {
  const n = Number(val);
  return !(Number.isFinite(n) && n > 0);
}

export async function fetchMissingDurations(autoSave = false) {
  if (selectedChannel === null || !catalog[selectedChannel]) return;
  const ch = catalog[selectedChannel];

  const minioVids = ch.videos.filter((v) => v.type === 'minio' && v.url && needsDurationSeconds(v.duration));
  const ytVids = ch.videos.filter((v) => v.type === 'youtube' && needsDurationSeconds(v.duration));

  const total = minioVids.length + ytVids.length;
  if (total === 0) {
    showToast('Todos los vídeos ya tienen duración');
    if (autoSave && window.saveCatalog) await window.saveCatalog();
    return;
  }

  let done = 0;
  let ok = 0;

  const updateToast = () =>
    showToast(`⏳ DURACIONES: ${done}/${total} (${ok} obtenidas)...`);
  updateToast();

  const fetchOneMinio = (vid) =>
    new Promise((resolve) => {
      const v = document.createElement('video');
      v.style.cssText = 'position:fixed;width:1px;height:1px;opacity:0;pointer-events:none';
      document.body.appendChild(v);
      v.preload = 'metadata';
      let settled = false;
      const finish = (dur) => {
        if (settled) return;
        settled = true;
        if (dur > 0) {
          vid.duration = Math.round(dur);
          ok++;
        }
        v.src = '';
        v.remove();
        done++;
        updateToast();
        resolve();
      };
      const t = setTimeout(() => finish(0), 10000);
      v.addEventListener('loadedmetadata', () => {
        clearTimeout(t);
        finish(v.duration);
      });
      v.addEventListener('error', () => finish(0));
      v.src = vid.url;
    });

  const BATCH = 6;
  for (let i = 0; i < minioVids.length; i += BATCH) {
    await Promise.all(minioVids.slice(i, i + BATCH).map(fetchOneMinio));
  }

  for (const vid of ytVids) {
    const id = normalizeYoutubeVideoId(vid.id ?? vid.video_id ?? '');
    if (!id) {
      done++;
      updateToast();
      continue;
    }
    const sec = await fetchDuration(id);
    if (sec > 0) {
      vid.duration = Math.round(sec);
      ok++;
    }
    done++;
    updateToast();
  }

  renderVideoList();
  if (autoSave) {
    showToast(`✓ ${ok}/${total} duraciones — guardando...`);
    if (window.saveCatalog) {
      await window.saveCatalog();
    } else {
      console.warn('saveCatalog not available for autoSave');
    }
    showToast(`✓ GUARDADO — ${ok}/${total} duraciones obtenidas`);
  } else {
    showToast(`✓ ${ok}/${total} duraciones obtenidas — guarda los cambios`);
  }
}
